import React from 'react';
import PropTypes from 'prop-types';

function DistributionChartTooltip(props) {
  const { tooltipModel, canvasRef } = props;
  if (!tooltipModel || !canvasRef.current) return null;
  const position = canvasRef.current.getBoundingClientRect();

  return (
    <div
      className="engage-results-open-budget-tooltip tooltip-wrapper"
      style={{
        opacity: tooltipModel.opacity,
        left: `${position.left + window.scrollX + tooltipModel.caretX}px`,
        top: `${position.top + window.scrollY + tooltipModel.caretY}px`,
      }}
    >
      <div className="engage-results-open-budget-tooltip__title">
        {tooltipModel.title.join(', ')}
      </div>
      <div className="engage-results-open-budget-tooltip__body">
        {tooltipModel.dataPoints.map((dataPoint) => (
          <div
            className="engage-results-open-budget-tooltip__data-points"
            key={dataPoint.datasetIndex}
          >
            <div className="engage-results-open-budget-tooltip__data-point">
              <div>{dataPoint.dataset.label}</div>
              <div>{dataPoint.formattedValue}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

DistributionChartTooltip.propTypes = {
  tooltipModel: PropTypes.shape({
    opacity: PropTypes.number.isRequired,
    caretX: PropTypes.number.isRequired,
    caretY: PropTypes.number.isRequired,
    title: PropTypes.arrayOf(PropTypes.string).isRequired,
    dataPoints: PropTypes.arrayOf(
      PropTypes.shape({
        datasetIndex: PropTypes.number.isRequired,
        dataset: PropTypes.shape({
          label: PropTypes.string.isRequired,
        }).isRequired,
        formattedValue: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }),
  canvasRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
};

DistributionChartTooltip.defaultProps = {
  tooltipModel: null,
};

export default DistributionChartTooltip;
